var _g, _path, _g2, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 38,
    viewBox: "0 0 49 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    filter: "url(#filter0_f_6144_14764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3492 35.9272C19.3956 37.8737 14.8748 38.503 10.7815 37.6765C6.68812 36.85 3.3575 34.6356 1.52231 31.5203C-0.31287 28.405 -0.502301 24.6441 0.995703 21.0649C2.49371 17.4857 5.55642 14.3814 9.51011 12.4349C13.4638 10.4884 17.9846 9.85923 22.0779 10.6857C26.1713 11.5122 29.5019 13.7266 31.3371 16.8419C33.1723 19.9571 33.3617 23.7181 31.8637 27.2973C30.3657 30.8765 27.3029 33.9807 23.3492 35.9272Z",
    fill: "url(#paint0_radial_6144_14764)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9699 18.5445C44.9907 20.3751 44.6546 22.1917 43.9808 23.8892C43.307 25.5866 42.309 27.131 41.0446 28.4331C39.7803 29.7351 38.2747 30.7688 36.6151 31.4743C34.9554 32.1798 33.1748 32.543 31.3762 32.543C29.5777 32.543 27.7971 32.1798 26.1375 31.4743C24.4779 30.7688 22.9723 29.7351 21.7079 28.4331C20.4436 27.131 19.4456 25.5866 18.7718 23.8892C18.098 22.1917 17.7618 20.3751 17.7827 18.5445C17.7618 16.7138 18.098 14.8972 18.7718 13.1998C19.4456 11.5024 20.4436 9.95791 21.7079 8.65589C22.9723 7.35387 24.4779 6.32017 26.1375 5.61467C27.7971 4.90917 29.5777 4.5459 31.3762 4.5459C33.1748 4.5459 34.9554 4.90917 36.6151 5.61467C38.2747 6.32017 39.7803 7.35387 41.0446 8.65589C42.309 9.95791 43.307 11.5024 43.9808 13.1998C44.6546 14.8972 44.9907 16.7138 44.9699 18.5445Z",
    fill: "#FFC01D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41827,
    filter: "url(#filter1_f_6144_14764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8133 25.783C28.4896 26.927 25.8325 27.2969 23.4267 26.8112C21.0209 26.3255 19.0634 25.0241 17.9848 23.1932C16.9062 21.3624 16.7949 19.152 17.6754 17.0485C18.5558 14.945 20.3559 13.1205 22.6797 11.9765C25.0034 10.8325 27.6605 10.4627 30.0663 10.9484C32.4721 11.4341 34.4296 12.7355 35.5082 14.5664C36.5868 16.3972 36.6981 18.6076 35.8177 20.7111C34.9372 22.8146 33.1371 24.6391 30.8133 25.783Z",
    fill: "url(#paint1_radial_6144_14764)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5261 15.7292C41.539 16.8586 41.3316 17.9793 40.9159 19.0266C40.5002 20.0738 39.8845 21.0266 39.1044 21.8299C38.3244 22.6332 37.3955 23.2709 36.3716 23.7062C35.3477 24.1414 34.2491 24.3656 33.1395 24.3656C32.03 24.3656 30.9314 24.1414 29.9075 23.7062C28.8836 23.2709 27.9547 22.6332 27.1747 21.8299C26.3946 21.0266 25.7789 20.0738 25.3632 19.0266C24.9475 17.9793 24.7401 16.8586 24.753 15.7292C24.7401 14.5998 24.9475 13.479 25.3632 12.4318C25.7789 11.3846 26.3946 10.4317 27.1747 9.62842C27.9547 8.82514 28.8836 8.1874 29.9075 7.75215C30.9314 7.31689 32.03 7.09277 33.1395 7.09277C34.2491 7.09277 35.3477 7.31689 36.3716 7.75215C37.3955 8.1874 38.3244 8.82514 39.1044 9.62842C39.8845 10.4317 40.5002 11.3846 40.9159 12.4318C41.3316 13.479 41.539 14.5998 41.5261 15.7292Z",
    fill: "url(#paint2_radial_6144_14764)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8815 25.7679C20.312 24.4898 19.8851 23.774 20.1236 22.3042C20.8017 24.1958 21.8062 25.6529 21.8815 25.7679Z",
    fill: "url(#paint3_radial_6144_14764)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0024 10.7373C49.0186 12.1572 48.7578 13.5663 48.2352 14.8829C47.7126 16.1995 46.9385 17.3974 45.9578 18.4073C44.9771 19.4172 43.8093 20.219 42.522 20.7662C41.2347 21.3135 39.8536 21.5952 38.4586 21.5952C37.0636 21.5952 35.6824 21.3135 34.3952 20.7662C33.1079 20.219 31.9401 19.4172 30.9594 18.4073C29.9787 17.3974 29.2046 16.1995 28.682 14.8829C28.1594 13.5663 27.8986 12.1572 27.9148 10.7373C27.8986 9.3174 28.1594 7.90833 28.682 6.59173C29.2046 5.27514 29.9787 4.07719 30.9594 3.06729C31.9401 2.05738 33.1079 1.2556 34.3952 0.70838C35.6824 0.161164 37.0636 -0.120605 38.4586 -0.120605C39.8536 -0.120605 41.2347 0.161164 42.522 0.70838C43.8093 1.2556 44.9771 2.05738 45.9578 3.06729C46.9385 4.07719 47.7126 5.27514 48.2352 6.59173C48.7578 7.90833 49.0186 9.3174 49.0024 10.7373Z",
    fill: "#FFC01D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8506 2.26367C46.4793 4.76878 47.5215 6.27697 47.2453 9.51061C45.4497 5.48454 43.0138 2.49373 42.8506 2.26367Z",
    fill: "url(#paint4_radial_6144_14764)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6144_14764",
    x: -2.56048,
    y: 7.77546,
    width: 37.9803,
    height: 32.8114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.27755,
    result: "effect1_foregroundBlur_6144_14764"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6144_14764",
    x: 13.5472,
    y: 7.20002,
    width: 26.3988,
    height: 23.3597,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.76986,
    result: "effect1_foregroundBlur_6144_14764"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6144_14764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9427 21.5946) rotate(68.6516) scale(22.7315 21.7718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.99107
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51389,
    stopOpacity: 0.61607
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6144_14764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.399 17.3597) rotate(68.6511) scale(13.3595 12.7962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.99107
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51389,
    stopOpacity: 0.61607
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6144_14764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1396 15.7292) scale(8.38712 8.53738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66667,
    stopColor: "#FFC01D",
    stopOpacity: 0.49804
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6144_14764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.267 24.11) rotate(146.584) scale(0.884802 3.56849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6144_14764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.498 5.64495) rotate(-37.9347) scale(1.93572 7.78643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinYellow);
export default __webpack_public_path__ + "static/media/pinYellow.2746c7b191fa8556b000f6f0cbf07817.svg";
export { ForwardRef as ReactComponent };